export default { number: "1.0.13044.0" };
